import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-subtitle-1 mb-2" }, "Foglalás elemek kiválasztása", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: $setup.dialog,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.dialog) = $event)),
    "max-width": "1100"
  }, {
    activator: _withCtx(({ props: activatorProps }) => [
      _createVNode(_component_v_btn, _mergeProps(activatorProps, {
        color: "primary",
        "prepend-icon": "mdi-plus"
      }), {
        default: _withCtx(() => [
          _createTextVNode("Új számla")
        ]),
        _: 2
      }, 1040)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_card, { title: "Új bejövő számla" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: $setup.form.identifier,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.identifier) = $event)),
                        label: "Számla azonosító",
                        variant: "outlined",
                        density: "compact"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        modelValue: $setup.form.status,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.status) = $event)),
                        items: $setup.statusOptions,
                        "item-title": "label",
                        "item-value": "value",
                        label: "Státusz",
                        variant: "outlined",
                        density: "compact"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        modelValue: $setup.form.type,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.type) = $event)),
                        items: $setup.typeOptions,
                        "item-title": "label",
                        "item-value": "value",
                        label: "Típus",
                        variant: "outlined",
                        density: "compact"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: $setup.form.amount,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.amount) = $event)),
                        label: "Számla összege",
                        type: "number",
                        suffix: "Ft",
                        variant: "outlined",
                        density: "compact"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider, { class: "my-4" }),
              _hoisted_1,
              _createVNode(_component_v_row, { class: "mb-4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: $setup.filters.accommodation,
                        "onUpdate:modelValue": [
                          _cache[4] || (_cache[4] = ($event: any) => (($setup.filters.accommodation) = $event)),
                          $setup.fetchBookingItems
                        ],
                        label: "Szálláshely",
                        variant: "outlined",
                        density: "compact",
                        clearable: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: $setup.filters.startDate,
                        "onUpdate:modelValue": [
                          _cache[5] || (_cache[5] = ($event: any) => (($setup.filters.startDate) = $event)),
                          $setup.fetchBookingItems
                        ],
                        label: "Érkezés (tól)",
                        type: "date",
                        variant: "outlined",
                        density: "compact",
                        clearable: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: $setup.filters.endDate,
                        "onUpdate:modelValue": [
                          _cache[6] || (_cache[6] = ($event: any) => (($setup.filters.endDate) = $event)),
                          $setup.fetchBookingItems
                        ],
                        label: "Távozás (ig)",
                        type: "date",
                        variant: "outlined",
                        density: "compact",
                        clearable: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_data_table, {
                modelValue: $setup.selectedItems,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.selectedItems) = $event)),
                headers: $setup.itemHeaders,
                items: $setup.bookingItems,
                "item-value": "id",
                "show-select": "",
                density: "compact"
              }, {
                "item.startDate": _withCtx(({ value }) => [
                  _createTextVNode(_toDisplayString(value), 1)
                ]),
                "item.endDate": _withCtx(({ value }) => [
                  _createTextVNode(_toDisplayString(value), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "items"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                variant: "text",
                onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.dialog = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Mégse")
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                color: "primary",
                disabled: !$setup.isValid,
                onClick: $setup.submit
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Mentés")
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}